import "./Footer.css";
import logo from "../photos/logo.png";
import { BsTelegram } from "react-icons/bs";
import { FaInstagram } from "react-icons/fa6";
import { IoIosMail } from "react-icons/io";
import { useT } from "../features/UseT";

function Footer() {
  const t = useT();
  return (
    <div className="Footer">
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <img src={logo} alt="logo" className="FooterLogo" />
        <span className="FooterText" style={{ margin: "0.8vw 0" }}>
          ©2026 Sigma.{" " + t.rights}
        </span>
        <div>
          <div className="FooterLinks" style={{ marginTop: "0.5vw" }}>
            <a href="mailto:support@simaring.io" style={{ margin: "0 1vw" }}>
              <IoIosMail color="#fff" className="Icons" />
            </a>
            <a
              href={t.ftel}
              target="_blank"
              rel="noreferrer"
              style={{ margin: "0 1vw" }}
            >
              <BsTelegram color="#fff" className="Icons" />
            </a>
            <a
              href={t.fig}
              target="_blank"
              rel="noreferrer"
              style={{ margin: "0 1vw" }}
            >
              <FaInstagram color="#fff" className="Icons" />
            </a>
          </div>
        </div>
      </div>
      <div className="FooterText">
        <a
          href="/termsandconditions"
          rel="noopener noreferrer"
          style={{ color: "#fff" }}
        >
          {t.tc}
        </a>
        <a
          href="/privacypolicy"
          rel="noopener noreferrer"
          style={{ color: "#fff" }}
        >
          {t.pp}
        </a>
        <a
          href="/refundandreturnpolicy"
          rel="noopener noreferrer"
          style={{ color: "#fff" }}
        >
          {t.rr}
        </a>
        <a
          href="/companydetails"
          rel="noopener noreferrer"
          style={{ color: "#fff" }}
        >
          {t.cd}
        </a>
        <a href={t.umurl} rel="noopener noreferrer" style={{ color: "#fff" }}>
          {t.um}
        </a>
      </div>
    </div>
  );
}

export default Footer;
